/**
 * Parallax effect for sections
 * Applies smooth parallax scrolling to media elements
 */

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-parallax-section]');
  if (!sections.length) return;

  // Respect users who prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Optional: disable on smaller screens
  const isMobile = window.innerWidth < 768;
  if (isMobile) return;

  let ticking = false;

  const update = () => {
    const vh = window.innerHeight;

    sections.forEach(section => {
      const media = section.querySelector('[data-parallax-media]');
      if (!media || !(media instanceof HTMLElement)) return;

      const rect = section.getBoundingClientRect();
      const strength = Number(section.getAttribute('data-parallax-strength') || 40);

      // -1 at top of viewport, 0 center, 1 at bottom
      const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      const translateY = -progress * strength;

      media.style.transform = `translate3d(0, ${translateY}px, 0)`;
    });
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
});
